import classes from 'components/common/CustomizedConfirmDeleteModal/CustomizedConfirmDeleteModal.module.scss';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Modal } from 'components/DesignSystem/Modal';
import { Button, CustomizedModalBase, CustomizedRoundIcon } from 'components/common';

interface ICustomizedConfirmDeleteModalProps {
    isShowModal: boolean;
    hideModal: () => void;
    text: string;
    onConfirm: () => void;
    isLoading?: boolean;
}

export const CustomizedConfirmDeleteModal = ({
    isShowModal,
    hideModal,
    text,
    onConfirm,
    isLoading = false,
}: ICustomizedConfirmDeleteModalProps) => {
    return (
        <Modal
            open={isShowModal}
            onClose={hideModal}
            actions={
                <>
                    <Button size={'medium'} variant={'secondary'} onClick={() => hideModal()} disabled={isLoading}>
                        Cancel
                    </Button>

                    <Button
                        data-testid={'delete-button'}
                        size={'medium'}
                        variant={'primary'}
                        destructive={true}
                        onClick={onConfirm}
                        isLoading={isLoading}
                    >
                        Delete
                    </Button>
                </>
            }
        >
            <div data-testid={'delete-message'} className={classes.deleteMessage}>
                <MuiIcon icon={'warning'} color={'var(--button-primary-bg_destructive)'} fontSize={'30px'} />
                <span className={classes.title}>{text}</span>
            </div>
        </Modal>
    );
};
